<template>
  <div class="wrapper" :class="[{'nav-open': $sidebar.showSidebar}]">
    <notifications></notifications>
    <top-navbar></top-navbar>
    <div class="main-panel">
      <div :class="[{content: !$route.meta.hideContent}, {'with-social-bar': showSocialBar}]" @click="toggleSidebar">
        <zoom-center-transition :duration="200" mode="out-in">
          <!-- your content here -->
          <router-view :regions="regions" :crops="crops" :data="data" ></router-view>
        </zoom-center-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar'
  import 'perfect-scrollbar/css/perfect-scrollbar.css'

  function hasElement (className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar (className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  import { mapState } from 'vuex'
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './Extra/MobileMenu.vue'
  import {SlideYDownTransition, ZoomCenterTransition} from 'vue2-transitions'

  export default {
    props:['regions','crops','data','regionsSection'],
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      SlideYDownTransition,
      ZoomCenterTransition
    },
    
    data() {
      return {
        showSocialBar: true
      }
    },

    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      handleScroll () {
        // Mostrar contenido con margen extra solo cuando la barra de redes está visible (scroll arriba)
        this.showSocialBar = window.scrollY <= 0
      }
    },
    mounted () {
      
      let docClasses = document.body.classList;
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        // if we are on windows OS we activate the perfectScrollbar function
        initScrollbar('sidebar');
        initScrollbar('sidebar-wrapper');
        initScrollbar('main-panel');

        docClasses.add('perfect-scrollbar-on')
      } else {
        docClasses.add('perfect-scrollbar-off')
      }

      // Inicializar estado de la barra social y escuchar scroll
      this.handleScroll()
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy () {
      window.removeEventListener('scroll', this.handleScroll)
    }
  }

</script>
<style lang="scss">
  $scaleSize: .95;
  @keyframes zoomIn95 {
    from {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
    to {
      opacity: 1;
    }
  }
  .main-panel .zoomIn {
    animation-name: zoomIn95;
  }
  .main-panel {
    width: 100% !important;
    float:none;
  }
  @keyframes zoomOut95 {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
      transform: scale3d($scaleSize, $scaleSize, $scaleSize);
    }
  }
  .main-panel .zoomOut {
    animation-name: zoomOut95;
  }
  
  .main-panel > .content {
    margin-top: 68px;
  }

  .main-panel > .content.with-social-bar {
    margin-top: 100px;
  }
</style>
